var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"yuyueRoom",attrs:{"src":require("@/assets/images/86.png"),"alt":"Lazy Loaded Image"},on:{"load":_vm.onImageLoad,"click":function($event){return _vm.$router.push('/home/teacher')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }